import { arrayToObject } from "lib/utils";

export const OBTypes = {
  FULL: 'full',
};

export const DAY_OF_WEEK = [
  { label: 'MONDAY', value: 1 },
  { label: 'TUESDAY', value: 2 },
  { label: 'WEDNESDAY', value: 3 },
  { label: 'THURSDAY', value: 4 },
  { label: 'FRIDAY', value: 5 },
  { label: 'SATURDAY', value: 6 },
  { label: 'SUNDAY', value: 7 },
];

export const DAYS_PER_WEEK = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
];

export const ACTIVITIES_PER_DAY = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
];

export const ASSESSMENTS_PER_CHILD = [
  { label: 'TIMES_PER_YEAR', value: 1 },
  { label: 'TIMES_PER_YEAR', value: 2 },
  { label: 'TIMES_PER_YEAR', value: 3 },
  { label: 'TIMES_PER_YEAR', value: 4 },
];

export const ROLES = [
  { label: 'OWNER', value: 'Owner' },
  { label: 'TEACHER', value: 'Teacher' },
  { label: 'ADMIN', value: 'Administrator' },
  { label: 'DIRECTOR', value: 'Director' },
  { label: 'CAREGIVER', value: 'Caregiver' },
];

export const ROLES_OBJECT = arrayToObject(ROLES, 'label');
